import { registerPlugin } from '@wordpress/plugins';

import sidebarPlugin from './sidebar';

registerPlugin(...sidebarPlugin);
